var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 2.66659C5.05709 2.66659 2.66927 5.0544 2.66927 7.99992C2.66927 10.9454 5.05709 13.3333 8.0026 13.3333C10.9481 13.3333 13.3359 10.9454 13.3359 7.99992C13.3359 5.0544 10.9481 2.66659 8.0026 2.66659ZM1.33594 7.99992C1.33594 4.31802 4.32071 1.33325 8.0026 1.33325C11.6845 1.33325 14.6693 4.31802 14.6693 7.99992C14.6693 11.6818 11.6845 14.6666 8.0026 14.6666C4.32071 14.6666 1.33594 11.6818 1.33594 7.99992ZM8.0026 5.08325C8.37079 5.08325 8.66927 5.38173 8.66927 5.74992V5.77629C8.66927 6.14448 8.37079 6.44295 8.0026 6.44295C7.63441 6.44295 7.33594 6.14448 7.33594 5.77629V5.74992C7.33594 5.38173 7.63441 5.08325 8.0026 5.08325ZM8.0026 7.33325C8.37079 7.33325 8.66927 7.63173 8.66927 7.99992L8.66927 10.9999C8.66927 11.3681 8.37079 11.6666 8.0026 11.6666C7.63441 11.6666 7.33594 11.3681 7.33594 10.9999V7.99992C7.33594 7.63173 7.63441 7.33325 8.0026 7.33325Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.6294ab3e78cbcea9836b300bad8768ed.svg";
export { ForwardRef as ReactComponent };